import { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";
import { API_BASE } from "../constants/index";
import toast from "react-hot-toast";
import {
    FiArrowLeft, FiChevronRight
} from "react-icons/fi";

const GET_ANNOUNCEMENT_LIST_API = `${API_BASE}/publicApi/getAnnList`;

export default function News() {
    const { t, language } = useTranslation();
    const navigate = useNavigate();
    const [announcementList, setAnnouncementList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [announcementListCount, setAnnouncementListCount] = useState(0);

    const getAnnouncementList = useCallback(async () => {
        try {
            const res = await fetch(GET_ANNOUNCEMENT_LIST_API, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                },
            });

            const responseData = await res.json();

            if (!res.ok) {
                // Preserve error details in the error object
                const error = new Error(responseData.message || responseData.error || `HTTP error! status: ${res.status}`);
                error.errorCode = responseData.errorCode || res.status;
                error.error = responseData.error || responseData.message;
                throw error;
            }

            const announcement_list = responseData.data;
            const announcement_array = [];
            const today_date = new Date().toISOString().split('T')[0];

            announcement_list.forEach((item) => {
                let title = item.ann_title_en_US;
                let content = item.ann_content_en_US;

                switch (language) {
                    case 'zh':
                        title = item.ann_title_zh_CN || title;
                        content = item.ann_content_zh_CN || content;
                        break;
                    case 'zh-TW':
                        title = item.ann_title_zh_TW || title;
                        content = item.ann_content_zh_TW || content;
                        break;
                    case 'ko':
                        title = item.ann_title_ko_KR || title;
                        content = item.ann_content_ko_KR || content;
                        break;
                    case 'ja':
                        title = item.ann_title_ja_JP || title;
                        content = item.ann_content_ja_JP || content;
                        break;
                    case 'vi':
                        title = item.ann_title_vi_VN || title;
                        content = item.ann_content_vi_VN || content;
                        break;
                    case 'id':
                        title = item.ann_title_id_ID || title;
                        content = item.ann_content_id_ID || content;
                        break;
                    case 'ta':
                        title = item.ann_title_ta_IN || title;
                        content = item.ann_content_ta_IN || content;
                        break;
                    case 'hi':
                        title = item.ann_title_hi_IN || title;
                        content = item.ann_content_hi_IN || content;
                        break;
                    default:
                        break;
                }

                if (item.ann_status == 'show' && item.ann_pdate <= today_date) {
                    announcement_array.push({
                        ann_title: title,
                        ann_content: content,
                        ann_cdate: item.ann_cdate,
                        ann_pdate: item.ann_pdate,
                        ann_id: item.ann_id
                    });
                }
            });

            setAnnouncementList(announcement_array);

        } catch (error) {
            console.error("Error getting announcement list:", error);
            toast.error(error);
        }
    }, [language]);

    useEffect(() => {
        getAnnouncementList();
    }, [getAnnouncementList]);

    return (
        <div className="flex flex-col gap-4">
            {/* Header */}
            <div className="flex items-center mb-2">
                <button onClick={() => navigate(-1)} className="mr-4 text-white hover:text-gray-300 transition-colors">
                    <FiArrowLeft size={24} />
                </button>
                <h1 className="text-2xl font-semibold text-white">{t('News')}</h1>
            </div>

            {/* List */}
            {announcementList.length > 0 ? (
                announcementList.map((item, index) => (
                    <div
                        key={index}
                        className="flex justify-between items-center bg-[#08030d] border border-[#231735] rounded-xl p-4 cursor-pointer hover:bg-[#12081c] transition-colors shadow-sm"
                        onClick={() => navigate(`/news/${item.ann_id || index}`)}
                    >
                        <div className="flex-1 pr-4">
                            <h2 className="text-[#beb0c9] text-sm sm:text-base font-medium mb-3 line-clamp-3 leading-relaxed">
                                {item.ann_title}
                            </h2>
                            <div className="flex items-center text-xs text-[#5e4f70]">
                                <span>{item.ann_pdate ? item.ann_pdate.substring(0, 10) : item.ann_cdate?.substring(0, 10)}</span>
                            </div>
                        </div>
                        <div className="text-white flex-shrink-0 ml-1">
                            <FiChevronRight size={24} />
                        </div>
                    </div>
                ))
            ) : (
                <div className="text-center text-gray-500 py-10">
                    {t('No news available')}
                </div>
            )}
        </div>
    );
}
